import { Routes } from "@angular/router";
import { MsalGuard } from "@azure/msal-angular";
import { environment } from "../environments/environment";
import { RedirectPageComponent } from "./core/components/redirect-page/redirect-page.component";
import { canDeactivateGuard } from "./core/guards/editing.guard";
import { fallbackRedirectGuard } from "./core/guards/fallback-redirect.guard";
import { personnelResolver } from "./core/resolvers/personal.resolver";

import { agreementResolver } from "./core/resolvers/agreement.resolver";
import { AgendaComponent } from "./presentation/pages/agenda/agenda.component";
import { RealCostComponent } from "./presentation/pages/real-cost/real-cost.component";

export const routes: Routes = [
  {
    path: "home",
    component: RealCostComponent,
    canActivate: [MsalGuard],
  },
  {
    path: "agenda",
    component: AgendaComponent,
    canActivate: [MsalGuard],
  },
  {
    path: "opportunity/:agreementId",
    loadComponent: () =>
      import("./presentation/pages/agreement/ag-page.component").then(
        (m) => m.AgPageComponent,
      ),
    resolve: { workloadInfo: agreementResolver },
    canActivate: [MsalGuard],
    canDeactivate: [canDeactivateGuard],
  },
  {
    path: "workload/:agreementId",
    loadComponent: () =>
      import("./presentation/pages/agreement/ag-page.component").then(
        (m) => m.AgPageComponent,
      ),
    resolve: { workloadInfo: agreementResolver },
    canActivate: [MsalGuard],
    canDeactivate: [canDeactivateGuard],
  },
  {
    path: "proposal/:agreementId",
    loadComponent: () =>
      import("./presentation/pages/agreement/ag-page.component").then(
        (m) => m.AgPageComponent,
      ),
    resolve: { proposalInfo: agreementResolver },
    canActivate: [MsalGuard],
    canDeactivate: [canDeactivateGuard],
  },
  {
    path: "prestaffing/:agreementId",
    loadComponent: () =>
      import("./presentation/pages/agreement/ag-page.component").then(
        (m) => m.AgPageComponent,
      ),
    resolve: { contractInfo: agreementResolver },
    canActivate: [MsalGuard],
    canDeactivate: [canDeactivateGuard],
  },
  {
    path: "contract/:agreementId",
    loadComponent: () =>
      import("./presentation/pages/agreement/ag-page.component").then(
        (m) => m.AgPageComponent,
      ),
    resolve: { contractInfo: agreementResolver },
    canActivate: [MsalGuard],
    canDeactivate: [canDeactivateGuard],
  },
  {
    path: "personnel/:resourceId",
    loadComponent: () =>
      import("./presentation/pages/personnel/personnel.component").then(
        (m) => m.PersonnelComponent,
      ),
    resolve: { personalInfo: personnelResolver },
    canActivate: [MsalGuard],
    canDeactivate: [canDeactivateGuard],
  },
  {
    path: "report/:reportId",
    loadComponent: () =>
      import("./presentation/pages/report/report.component").then(
        (m) => m.ReportComponent,
      ),
    canActivate: environment.production ? [MsalGuard] : undefined,
  },
  {
    path: "evaluation/report",
    loadComponent: () =>
      import("./presentation/pages/report-evaluation/report-evaluation.component").then(
        (m) => m.ReportEvaluationComponent,
      ),
    canActivate: environment.production ? [MsalGuard] : undefined,
  },
  {
    path: "pay-cor",
    loadComponent: () =>
      import("./presentation/pages/pay-cor/pay-cor.component").then(
        (m) => m.PayCorComponent,
      ),
    canActivate: [MsalGuard],
  },
  { path: "redirect", component: RedirectPageComponent },
  { path: "", pathMatch: "full", canMatch: [fallbackRedirectGuard], component: RedirectPageComponent },
  { path: "**", canMatch: [fallbackRedirectGuard], component: RedirectPageComponent },
];
